/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=0f17d36a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f17d36a&lang=scss"

import exportComponent from "D:\\Workspace\\WMS_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__